module.exports = __webpack_public_path__ + "assets/nodata.df64a481.svg";